<template>
<header class="order-details-header-component">
  <h3 class="order-details-header-component__title">Заказ №{{ order.number }}</h3>
  <span :style="statusInfo.style" class="order-details-header-component__status">{{ statusInfo.text }}</span>
  <!-- TODO 'Повторить' -->
  <div class="order-details-header-component__spacer"></div>
  <!-- TODO Should back button action be different from `back` if the prev page is not the orders list page,
  like with products? -->
  <button
    class="order-details-header-component__close-link"
    @click="$router.back()"
  >Закрыть</button>
</header>
</template>

<script>
export default {
  props: {
    order: {
      required: true,
      type: Object,
    },
    statusInfo: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="less">
@import '../../../pages/profile/common.less';

.order-details-header-component:extend(.profile__card-header) {
  &__title:extend(.profile__card-header-title) {}
  &__status {
    @apply mx-1 rounded-full py-1 px-3 text-xs whitespace-no-wrap;
  }
  &__spacer {
    @apply flex-grow;
  }
  &__close-link:extend(.profile__card-header-button) {}
}
</style>
